<template>
  <div>
    <w-dialog :show="show" :wallStyle="{zIndex: 2001}" :boxStyle="{boxSizing: 'border-box', width: '472px', height: '610px', padding: '60px', zIndex: '2001'}" :bodyStyle="{padding: '0px'}">
      <div class="flex flex-column justify-center align-center">
        <img class="flex-1" src="@/assets/images/pic.png" width="209" height="111" alt="密保手机">
        <p class="flex-1 binding-title">请设置您的密保手机</p>
        <div class="binding-msg">
          <span class="bind-mobile-msg"><i class="r2-icon-check login-close"></i>账号安全有保障</span><span class="bind-mobile-msg"><i class="r2-icon-check login-close"></i>手机号登录更方便</span>
        </div>

        <!-- <p class="flex-1 binding-msg text-align-center">关联后可通过手机号进行快捷登录，且忘记密码也可通过手机号找回密码。</p> -->
      </div>
      <w-form ref="formData" :model="formData" label-width="70px" :rules="importRules" label-position="left">
        <w-form-item label="手机号" prop="mobile">
          <w-input size="small" v-model.trim="formData.mobile" placeholder="请输入手机号码" clearable></w-input>
        </w-form-item>
        <w-form-item label="验证码" prop="verifyCode">
          <w-input style="width: 170px; margin-right: 10px;" size="small" v-model.trim="formData.verifyCode" placeholder="6位验证码" clearable @change="handleChange"></w-input>
          <w-button style="width: 100px; paddingLeft: 0; paddingRight: 0;" type="minor" :disabled="!/^1[3456789]{1}\d{9}$/.test(formData.mobile) || !formData.timer==0" @click.prevent.stop>
            <Countdown :time="formData.timer" @click.native="getVerification" @finish="formData.timer=0" />
          </w-button>
        </w-form-item>
        <w-form-item label="姓名" prop="name" v-if="roleData!=1 && roleData!=5">
          <w-input size="small" v-model.trim="formData.name" placeholder="方便公司同事与您联系" clearable @change="handleChange"></w-input>
        </w-form-item>
      </w-form>
      <div class="operate-button text-align-center">
        <p class="error-msg">{{error}}</p>
        <w-button style="width: 200px;" type="primary" @click.prevent.stop="handlerSubmit()" :disabled="!formData.mobile || !formData.verifyCode || !/^1[3456789]{1}\d{9}$/.test(formData.mobile) || formData.name.length>30">
          提交
        </w-button>
      </div>
      <!-- 网易易盾 -->
      <div  ref="captcha"></div>
    </w-dialog>
  </div>
</template>
<style lang="less" type="text/less">
  .binding-title {
    font-size: 18px;
    font-weight: 500;
    color: #212530;
    line-height: 26px;
    margin-top: 38px;
  }
  .binding-msg{
    margin-top: 16px;
    margin-bottom: 43px;
  }
  .bind-mobile-msg{

    font-size: 14px;
    font-weight: 400;
    color: #00C461;
    line-height: 24px;
    &+ .bind-mobile-msg{
      margin-left: 20px;
    }
    i{
      margin-right: 8px;
      font-size: 24px;
      vertical-align: top;
    }
  }
  .r2-icon-alert_error{
    font-size: 20px;
    color: #fe9b07;
  }
  .w__form-item{
    margin-bottom: 24px;
  }

  .operate-button{
    margin-top: 50px;
    position: relative;
  }
  .error-msg{
    color: red;
    text-align: center;
    position: absolute;
    top: -28px;
    width: 100%;
  }
</style>
<script>
import api from 'service'
import LoginService from '@/assets/service/login'
import Countdown from '_c/common/countDown'
import {mapState, mapMutations} from 'vuex'
import { aes, appId, captchaId } from '@/assets/utils/CommonUtil'
let captchaIns
export default {
  name: 'BindMobilePhone',
  props: {
    show: {
      type: Boolean,
      require: false,
      default: false
    }
  },
  components: {
    Countdown
  },
  data () {
    // 请输入手机号码
    const validateMobile = (rule, value, callback) => {
      if (value === '') {
        return callback(new Error('请输入手机号码'))
      } else if (!/^1[3456789]{1}\d{9}$/.test(value)) {
        return callback(new Error('请输入正确的手机号码'))
      } else {
        callback()
      }
    }
    // 请输入验证码
    const validateCode = (rule, value, callback) => {
      if (value === '') {
        return callback(new Error('请输入验证码'))
      } else {
        callback()
      }
    }
    return {
      formData: {
        mobile: '',
        verifyCode: '',
        sign: '',
        timer: 0,
        name: ''
      },
      error: '',
      importRules: {
        mobile: [
          {required: true, validator: validateMobile, trigger: 'blur'}
        ],
        verifyCode: [
          {required: true, validator: validateCode, trigger: 'blur'}
        ],
        name: [
          {max: 30, message: '长度不能超过30个字符', trigger: 'blur'}
        ]
      },
      error: '',
      roleData: 5
    }
  },
  computed: {
    ...mapState({
      userData: state => state.user.user
    })
  },
  methods: {
    getVerification () {
      let reg = /^1[3456789]{1}\d{9}$/
      if (!reg.test(this.formData.mobile) || this.formData.timer > 0){
        return
      }
      captchaIns && captchaIns.verify()
    },
    // 1.2 网易易盾验证成功回调
    verifyCallback (verifyOptions = {}) {
      let that = this
      let {postfix = '', showAddMember = false, uploadVisible = false, memberInfo = {}, isEditor = false} = that
      let suffix = `@${postfix}`
      captchaIns && captchaIns.refresh()
      // 获取短信
      let time = new Date().getTime()
      let query = {
        appId,
        sign: aes(time, this.formData.mobile),
        t: time
      }
      let params = {
        captchaCode: verifyOptions.validate,
        captchaId,
        mobile: this.formData.mobile
      }
      LoginService.getMobileCode(query, params).then((res) => {
        console.log(res)
        if (res.code === 200) {
          this.formData.timer = 60
        } else {
          this.$message.error(res.message || '获取验证码失败')
        }
      }).catch((e) => {
        this.$message.error('获取验证码失败')
      })
    },
    // 1.3 网易易盾初始化
    initNECaptchaDom () {
      let that = this
      window.initNECaptcha({
        element: this.$refs.captcha, // 验证码容器元素ID
        captchaId, // 由用户中心分配
        mode: 'bind',
        width: '320px',
        onVerify (err, data) {
          // 用户验证码验证成功后，进行实际的提交行为
          if (data) {
            that.verifyCallback({validate: data.validate, captchaId})
          }
        }
      }, instance => {
        // 初始化成功后得到验证实例instance，可以调用实例的方法
        captchaIns = instance
      }, err => {
        // 初始化失败后触发该函数，err对象描述当前错误信息
        console.log(err)
      })
    },
    // 1.4 提交表单
    handlerSubmit () {
      this.error = null
      let params = {
        mobile: this.formData.mobile.trim(),
        verifyCode: this.formData.verifyCode.trim()
      }
      if (this.roleData !== 1 && this.roleData !== 5) {
        params.name = this.formData.name.trim()
      }
      api.user.postPasswordMobile(params).then(data => {
        console.log('------ checkPasswordMobile ------')
        console.log(data)
        if (+data.code === 200) {
          this.$emit('postPasswordMobile', params.mobile)
        } else {
          this.error = data.message
        }
      }).catch((e) => {
        this.error = '绑定密保手机失败！'
      })
    },
    // 2.1 s输入框
    handleChange () {

    }
  },
  created () {

  },
  mounted () {
    this.initNECaptchaDom()
    if (this.userData.role) {
      this.roleData = this.userData.role
      sessionStorage.setItem('tempRole', this.userData.role)

    } else {
      this.roleData = sessionStorage.getItem('tempRole')
    }

  }
}
</script>
